var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 29,
    height: 29,
    transform: "translate(0 -0.436)",
    fill: "#5ac2f8",
    stroke: "#5ac2f8",
    strokeWidth: 0.75
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(29 28.564) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M40.228,16.6a1.19,1.19,0,0,0-2.066,1.181l4.424,7.741-4.423,7.741a1.19,1.19,0,1,0,2.066,1.179l4.761-8.331a1.189,1.189,0,0,0,0-1.181Z",
    transform: "translate(-26.697 -11.24)",
    fill: "#5ac2f8",
    stroke: "#5ac2f8",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M14.282,0A14.282,14.282,0,1,0,28.564,14.282,14.283,14.283,0,0,0,14.282,0m0,26.184a11.9,11.9,0,1,1,11.9-11.9,11.915,11.915,0,0,1-11.9,11.9",
    fill: "#5ac2f8",
    stroke: "#5ac2f8",
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPrev);
export default __webpack_public_path__ + "static/media/banner-prev.87e2481bc79feb11c0897931c9f5431b.svg";
export { ForwardRef as ReactComponent };